import { claimIdentity, userSecurity } from '../../webmodule-common/other/api/user-security';

export function isAdmin(): boolean {
  return (
    userSecurity().claimIsTrue(claimIdentity.licenseServerAdmin) ||
    userSecurity().claimIsTrue(claimIdentity.admin) ||
    userSecurity().claimIsTrue(claimIdentity.superAdmin)
  );
}

export function isSupportManager(): boolean {
  return (
    userSecurity().claimIsTrue(claimIdentity.licenseServerAdmin) ||
    userSecurity().claimIsTrue(claimIdentity.supportManager) ||
    userSecurity().claimIsTrue(claimIdentity.admin) ||
    userSecurity().claimIsTrue(claimIdentity.superAdmin)
  );
}
